export default __webpack_public_path__ + "static/media/miguel-lopes-42.711d1afc.jpg";